import(/* webpackMode: "eager" */ "/tmp/8def3a33ae14520/app/global-error.tsx");
